import OutputController from "./output-controller";
import { IConfiguration } from "../../typings";

export default class UnitSystemController {
  private conf: IConfiguration;
  outputController: OutputController;
  private decimalCharacter: DecimalCharacter;

  constructor(conf: IConfiguration, outputController: OutputController) {
    this.outputController = outputController;
    this.conf = conf;
  }

  getUnitSystem(): UnitSystem {
    if (!this.unitSystem) {
      this.saveUnitSystem(this.conf.unitSystem);
    }
    return this.unitSystem;
  }

  getDecimal(): DecimalCharacter {
    if (!this.decimal) {
      this.saveDecimal(this.conf.decimalCharacter);
    }
    return this.decimal;
  }

  get unitSystem(): UnitSystem {
    return this.outputController.getValue(["system", "unit-system"]);
  }

  get decimal(): DecimalCharacter {
    return this.decimalCharacter;
  }

  async saveUnitSystem(unitSystem: UnitSystem): Promise<void> {
    await this.outputController.setValue(["system", "unit-system"], unitSystem);
  }

  async saveDecimal(decimalCharacter: DecimalCharacter): Promise<void> {
    this.decimalCharacter = decimalCharacter;
  }

  convertUnit(value: number): string {
    if (!value) {
      value = 0;
    }

    const type: string = this.getUnitSystem();
    const decimal: string = this.getDecimal();
    if (type === "imperial") {
      value = value * 0.0393700787;
      return value.toFixed(2).replace(".", decimal);
    }
    return (value * 0.1).toFixed(1).replace(".", decimal);
  }

  convertUnitWithSystem(value: number): string {
    if (!value) {
      value = 0;
    }

    const type: string = this.getUnitSystem();
    if (type === "imperial") {
      return this.convertUnit(value) + '"';
    }
    return this.convertUnit(value) + " cm";
  }
}

export enum UnitSystem {
  METRIC = "metric",
  IMPERIAL = "imperial",
}

export enum DecimalCharacter {
  DOT = ".",
  COLON = ",",
}
